/** The database's refusal of a second church's staff access (ADR 0068): SQLSTATE 23514 with this message key. */
export const STAFF_ELSEWHERE = "staff_elsewhere";

/**
 * What every screen that grants access says for that refusal (spec 2026-10-08 piece 1; data decision D31). It says the
 * email has staff access somewhere on HoW, never which church.
 */
export const STAFF_ELSEWHERE_SENTENCE =
  "This email can't get staff access here. On HoW, one email has staff access at one church. Ask the person for a different email address.";

/** Whether an error is that refusal: from an RPC (23514, message staff_elsewhere) or from invite-member (its code). */
export function isStaffElsewhere(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;
  const e = error as { code?: unknown; message?: unknown };
  return e.code === STAFF_ELSEWHERE || (e.code === "23514" && e.message === STAFF_ELSEWHERE);
}
